import { motion, useReducedMotion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", as = "div" }) => {
  const reduce = useReducedMotion();
  const Comp = motion[as];
  return (
    <Comp
      className={className}
      initial={reduce ? false : { opacity: 0, y: 18 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </Comp>
  );
};

export const SectionHeading = ({ eyebrow, title, intro, className = "", dark = false }) => (
  <div className={`max-w-3xl ${className}`}>
    {eyebrow && <p className={`eyebrow ${dark ? "!text-blue-300" : ""}`}>{eyebrow}</p>}
    <h2 className={`h-section mt-5 ${dark ? "!text-white" : ""}`}>{title}</h2>
    {intro && <p className={`lead mt-6 ${dark ? "!text-slate-300" : ""}`}>{intro}</p>}
  </div>
);

export const NetworkMotif = ({ className = "", light = false }) => {
  const stroke = light ? "rgba(255,255,255,0.18)" : "rgba(11,18,32,0.12)";
  const nodes = [[40, 60], [160, 30], [260, 110], [120, 170], [320, 40], [380, 180], [220, 240], [60, 260], [340, 290]];
  const edges = [[0, 1], [1, 2], [0, 3], [3, 2], [1, 4], [4, 5], [2, 5], [3, 6], [6, 5], [7, 3], [7, 6], [6, 8], [5, 8]];
  return (
    <svg viewBox="0 0 420 320" className={className} aria-hidden="true" fill="none">
      {edges.map(([a, b]) => (
        <line key={`${a}-${b}`} x1={nodes[a][0]} y1={nodes[a][1]} x2={nodes[b][0]} y2={nodes[b][1]} stroke={stroke} strokeWidth="1" />
      ))}
      {nodes.map(([x, y], i) => (
        <circle key={i} cx={x} cy={y} r={i === 2 ? 4 : 2.5} fill={i === 2 ? "#2563EB" : stroke} />
      ))}
    </svg>
  );
};
